import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";
import styles from "./AuthShell.module.scss";

type AuthMode = "login" | "signup" | "forgot-password" | "reset-password";

interface AuthShellProps {
  mode: AuthMode;
  title?: string;
  subtitle?: string;
  children: ReactNode;
}

export function AuthShell({ mode, title: customTitle, subtitle: customSubtitle, children }: AuthShellProps) {
  let title = customTitle;
  let subtitle = customSubtitle;

  if (!title) {
    if (mode === "signup") {
      title = "Create account";
    } else if (mode === "forgot-password") {
      title = "Reset password";
    } else if (mode === "reset-password") {
      title = "New password";
    } else {
      title = "Sign in";
    }
  }

  if (!subtitle) {
    if (mode === "signup") {
      subtitle = "Create your GoodBaby parent account.";
    } else if (mode === "forgot-password") {
      subtitle = "Enter your email to receive a password reset link.";
    } else if (mode === "reset-password") {
      subtitle = "Set a new password for your account.";
    } else {
      subtitle = "Welcome back to GoodBaby.";
    }
  }

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        {/* Top navigation */}
        <header className={styles.topbar}>
          <Link to="/" className={styles.backLink}>
            <ArrowLeft size={16} strokeWidth={2.2} />
            <span>Home</span>
          </Link>

          <div className={styles.brandBadge}>
            <img src="/logo.svg" alt="GoodBaby" className={styles.logo} />
            <span className={styles.brandText}>GoodBaby</span>
          </div>
        </header>

        {/* Content */}
        <div className={styles.content}>
          <div className={styles.intro}>
            <p className={styles.eyebrow}>Account</p>
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>

          <div className={styles.authCard}>
            {children}
          </div>

          <div className={styles.securityNote}>
            <Shield size={13} />
            <span>End-to-end encrypted connection</span>
          </div>
        </div>
      </div>
    </div>
  );
}
